// eslint-disable-next-line max-len
var WEATHER_MOON_NIGHT_FILLED = 'm30.11,26.79l-2.59,1.96c-2.68,2.03-6.02,3.25-9.64,3.25-8.83,0-15.99-7.16-16-16C1.89,7.19,9.01.05,17.82.01h3s-2.39,1.8-2.39,1.8c-3.38,2.56-5.56,6.59-5.56,11.15,0,3.87,1.57,7.36,4.1,9.9,2.53,2.53,6.02,4.09,9.88,4.1l3.27-.17Z';

export { WEATHER_MOON_NIGHT_FILLED };
//# sourceMappingURL=WEATHER_MOON_NIGHT_FILLED.js.map
